import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { McqService } from '../../service/mcq.service';
import { commonService } from '../../service/common.service';
import { HttpErrorResponse } from '@angular/common/http';

import { ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'app-solutionreport',
  templateUrl: './solutionreport.component.html',
  styleUrls: ['./solutionreport.component.css'],
  providers: [McqService],
  encapsulation: ViewEncapsulation.None,
})
export class SolutionreportComponent implements OnInit {
  @Input() testPaperId: any;
  reportId: any;
  userData: any;
  msg = '';
  isError = false;
  solutionReport: any;
  studentId: any;
  topperId: any;
  toppersReport: any = [];
  myReport: any = [];
  correctMyReport: any = [];
  incorrectMyReport: any = [];
  skippedMyReport: any = [];
  isPostLoad = true;
  answerCount: any = {};
  correctAnsCount: any = {};
  difficultyLevel: any = {};

  constructor(private route: ActivatedRoute, private router: Router, private mcqservice: McqService, private commonService: commonService) {
    this.userData = this.commonService.user;
  }

  ngOnInit() {
    this.reportId = this.testPaperId.reportId;
    this.topperId = this.testPaperId.toperId;
    this.studentId = this.userData.id;

    //console.log('solution report', this.testPaperId.reportId, this.testPaperId.toperId);
    if (this.reportId > 0 && this.studentId) {
      this.getSolutionReport();
      this.getStudentQuestionWiseCount();
    }
  }

  getSolutionReport() {
    let obj = {};
    obj['paperId'] = this.reportId;
    obj['topperId'] = this.topperId;
    obj['studentId'] = this.studentId;
    this.myReport = [];
    this.toppersReport = [];
    this.mcqservice.getSolutionReport(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.myData.length > 0) {
          this.solutionReport = data.results;
          this.myReport = data.results.myData;
          //this.toppersReport = data.results.toppersData;
          for (let output of data.results.toppersData) {
            this.toppersReport[parseInt(output.qID)] = parseInt(output.spendedTime);
          }

          this.getAnswerTypeReport(this.myReport);
          //console.log('gg', this.toppersReport);
        } else {
          this.solutionReport = [];
          this.myReport = [];
          this.toppersReport = [];
        }
        this.isPostLoad = false;
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.msg = "internal server error!";
    });
  }

  getTimeFormat(seconds) {
    seconds = (seconds>0) ? seconds : 0;
    return this.mcqservice.getFormatTime(seconds);
  }

  getAnswerTypeReport(myreport) {
    for (let i of myreport) {
      if (i.selectedOptionId == i.answer) {
        this.correctMyReport.push(i);
      } else if (i.selectedOptionId != i.answer && i.selectedOptionId != '0' && i.selectedOptionId != null) {
        this.incorrectMyReport.push(i);
      } else if (i.selectedOptionId == '0' || i.selectedOptionId == null) {
        this.skippedMyReport.push(i);
      }
    }
  }

  /*getStudentQuestionWiseCount(){
    let obj = {};
    obj['paperId']=this.reportId; 
    this.answerCount = {};
    this.correctAnsCount = {};
    this.mcqservice.getStudentQuestionWiseCount(obj).subscribe((data:any)=>{
      if(data.error==0){ 
        if(data.results.correctAnsCount.length > 0){
          //--------------------
          for(let i of data.results.ansCount){
            this.answerCount[i.questionId] = i.count;
          }
          for(let i of data.results.correctAnsCount){
            this.correctAnsCount[i.questionId] = i.count;
          }
          //---------------------------
          console.log(this.answerCount,this.correctAnsCount);
        }else{
          console.log("No record found!");
        }
        
      }else{
        if(data.message=="Failed to authenticate token."){
          console.log("Failed to authenticate token.");
        }else{
         console.log(data.message);
        }
      }
    },(error : HttpErrorResponse)=>{    
      console.log("internal server error!");
    });    
  }*/

  getStudentQuestionWiseCount() {
    let obj = {};
    obj['paperId'] = this.reportId;
    this.difficultyLevel = {};
    this.correctAnsCount = {};
    this.mcqservice.getStudentQuestionWiseCount(obj).subscribe((data: any) => {
      if (data.error == 0) {
        if (data.results.data.length > 0) {
          //--------------------
          for (let output of data.results.data) {
            var result: any = 0;
            result = Math.round(parseInt(output.rightAns) * 100 / parseInt(output.NoStudentsAttempted)).toFixed(2);
            this.difficultyLevel[parseInt(output.qID)] = result;
          }
          //---------------------------
          // console.log(this.difficultyLevel);
        } else {
          console.log("No record found!");
        }

      } else {
        if (data.message == "Failed to authenticate token.") {
          console.log("Failed to authenticate token.");
        } else {
          console.log(data.message);
        }
      }
    }, (error: HttpErrorResponse) => {
      console.log("internal server error!");
    });
  }

  getAccuracy(id) {
    /*let c = !isNaN(parseFloat(this.correctAnsCount[id])) ? this.correctAnsCount[id] : 0;
    let a = !isNaN(parseFloat(this.answerCount[id])) ? this.answerCount[id] : 0;
    return Math.round( (c*100)/a).toFixed(2);*/
    if (this.difficultyLevel) {
      return this.difficultyLevel[parseInt(id)];
    }
  }

  getQtype(type) {
    if (type == '1') {
      return 'Easy';
    } else if (type == '2') {
      return 'Medium';
    } else if (type == '3') {
      return 'Difficult';
    }
  }

  getDifficultyLevel(questId) {
    var result: any = 0;
    if (this.difficultyLevel) {
      result = this.difficultyLevel[questId];
      if (result >= 60) {
        return 'Easy';
      } else if (result >= 40 && result < 60) {
        return 'Medium';
      } else if (result < 40) {
        return 'Difficult';
      }
    }

  }
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/solutionreport/solutionreport.component.ts